import React, { useEffect, useContext, useState, useRef } from "react";
import { NavLink } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import moment from "moment";
import { FaFileInvoice } from "react-icons/fa";
//functions
import {
  _t,
  currencySymbolLeft,
  currencySymbolRight,
  getCookie,
  paginationLoading,
  paginationOrderHistory,
  showingDataOrderHistory,
  getSystemSettings,
  checkPermission,
  encryptAES128,
  customStyle
} from "../../../../functions/Functions";
import { useCustomHooks } from "../../../../functions/Hooks";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "react-moment";
import { useReactToPrint } from "react-to-print";

//importing context consumer here
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { FoodContext } from "../../../../contexts/Food";
import OrderPrintView from "../pos/modal/OrderPrintView";
import OrderDetailsView from "../pos/modal/OrderDetailsView";
import OrderFeedbackModal from './OrderFeedbackModal';
import ViewAccountSheet from "../accounts/transactions/ViewAccountSheet";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import { ToastError, ToastSuccess } from "../../../../functions/ToastShow";

const OrderHistories = () => {
  //getting context values here
  const {
    //common
    generalSettings,
  } = useContext(SettingsContext);
  const { authUserInfo, getCustomer, customerForSearch } = useContext(UserContext);

  const {
    //branch
    branchForSearch,

    //order histories
    getAllOrders,
    allOrders,
    setPaginatedAllOrders,
    setPaginatedFilteredOrders,
    setPaginatedSearchOrders,
    allOrdersForSearch,
    setAllOrdersForSearch,
    //pagination
    dataPaginating,
    setDataPaginating,
  } = useContext(RestaurantContext);

  const {
    //common
    loading,
    setLoading,
  } = useContext(FoodContext);

  const { t } = useTranslation();
  const { taxPercent, roundFormatPrice } = useCustomHooks();
  //print bills
  const componentRef = useRef();

  // States hook here
  const [ledgerData, setLedgerData] = useState({
    modal: false,
    ledger: null
  })
  //settle order
  const [checkOrderDetails, setCheckOrderDetails] = useState({
    item: null,
    settle: false,
    uploading: false,
    payment_type: null,
    payment_amount: null,
  });
  const [feedbackDetails, setFeedbackDetails] = useState({
    item: null,
    feedback: "",
    category:"",
    reason:"",
    desc: "",
    view: false,
    modal: false,
  });
  const [taxType, setTaxType] = useState("");
  //search result
  let [searchedOrders, setSearchedOrders] = useState({
    list: null,
    searched: false,
    branch: null,
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterCustomer, setFilterCustomer] = useState(null);

  // Debounced customer search (react-select)
  const [customerSearchResults, setCustomerSearchResults] = useState([]);
  const [customerSearchInput, setCustomerSearchInput] = useState("");
  const [customerSearchLoading, setCustomerSearchLoading] = useState(false);
  const [customerNoOptionMessage, setCustomerNoOptionMessage] = useState(_t(t("Enter Phone No To Search")));
  const [filtered, setFiltered] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const isSettle = useRef(0);

  //useEffect == componentDidMount
  // useEffect(() => {
  //   if(!customerForSearch){
  //     getCustomer();
  //   }
  // }, []);
 
  // useEffect(() => {
  //   if (!searched) setSearchInput("");
  // }, [searched]);

  useEffect(() => {
    if (!generalSettings || !Object.keys(generalSettings)?.length) return;
    setTaxType(getSystemSettings(generalSettings, "tax_type"));
  }, [generalSettings]);

  //cancel order confirmation modal
  const handleDeleteOrderConfirmation = (orderGroup) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">
              {_t(t("You want to delete this order?"))}
            </p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteOrder(orderGroup);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //history account ledger
  const handlePosLedger = async(id) =>{
    const url = BASE_URL + "/settings/check-financial-ledger-view/" + parseInt(id) + "/POS";
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLedgerData({ modal: true, ledger: res.data});
      }
    }catch(err){
      console.log("error==>",err)
    }
  }

  //post account ledger
  const handlePostLedger = async(id, branch_id) =>{
    const url = BASE_URL + "/settings/order-ledger-entry/" + parseInt(id) + "/" + branch_id;
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data.status === "success"){
        ToastSuccess(`${_t(t(res.data.message))}`);
      }else{
        ToastError(`${_t(t(res.data.message))}`);
      }
    }catch(err){
      console.log("error==>",err)
      ToastError({title: "Please try again"});
    }
  }

  //feeback details modal
  const handleOrderFeedback = (order, view = false) => {
    if(!order.is_cancelled){
      if(view && order.customer_feedback){
        setFeedbackDetails({
          item: null,
          desc: order?.remarks,
          category:"",
          feedback: order.customer_feedback?.feedback,
          reason: order.customer_feedback?.reason,
          view: true,
          modal: true,
        });
      }else if(!view){
        setFeedbackDetails({
          item: {
            customer_id: order.customer_id,
            cutomer_name: order.customer_name,
            order_date: order.order_date,
            branch_id: order.branch_id,
            order_id: order.id,
            token: order.token.id,
            address: order.address,
            delivery_phn_no: order.delivery_phn_no,
            delivery_address: order.delivery_address,
            total_payable: order.total_payable,
          },
          desc: "",
          feedback: "",
          category:"",
          reason: "",
          view: false,
          modal: true,
        });
      }
    }
  };

  //cancel order here
  const handleDeleteOrder = (orderGroup) => {
    let url = BASE_URL + "/settings/delete-order-from-history";
    let formData = {
      id: orderGroup.id,
    };
    setLoading(true);
    axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then(() => {
        
        ToastSuccess(`${_t(t("Deleted successfully"))}`);
      })
      .catch(() => {
        ToastError({title: "Please try again"});
      }).finally(() => {
        setLoading(false);
        setFiltered(false);
        setSearched(false);      });
  };

  //search submitted orders here
  const handleSearch = (e) => {
    e.preventDefault();
    // if (searchInput) {
    //   setPaginatedSearchedOrders(createSearchObj(1));
    //   setSearched(true);
    //   if (filtered) setFiltered(false);
    // } else {
    //   setSearched(false);
    // }
    let inputSearch = searchInput.toLowerCase();
    if (inputSearch.length === 0) {
    setSearchedOrders({ ...searchedOrders, searched: false });
    setSearched(false);
    } else {
    setSearched(true);
    let searchedList = allOrders?.data.filter((item) => {
      //token
      let lowerCaseItemToken = item.token?.id && JSON.stringify(item.token.id)?.toLowerCase();
      let orderNo = item?.order_no && item.order_no.toString();

      //customer
      let lowerCaseItemCustomer = item?.customer_name?.toLowerCase();
    
      //branch
      let lowerCaseItemBranch = item?.branch_name?.toLowerCase();
      return (
        (lowerCaseItemToken && lowerCaseItemToken.includes(inputSearch)) ||
        (lowerCaseItemCustomer && lowerCaseItemCustomer.includes(inputSearch)) ||
        (lowerCaseItemBranch && lowerCaseItemBranch.includes(inputSearch)) ||
        (orderNo && orderNo.includes(inputSearch))
      );
    });
    
    setAllOrdersForSearch({
      data:searchedList,
      meta: {
          "current_page": 1,
          "from": 1,
          "last_page": Math.ceil(searchedList?.length/100),
          "per_page": 100,
        }
    })
    // setSearchedOrders({
    //   ...searchedOrders,
    //   list: searchedList,
    //   searched: true,
    // });
    }
  };
 
  const createFilterObj = (page) => {
    const fromDate = moment(startDate).format("YYYY-MM-DD");
    const toDate = moment(endDate).format("YYYY-MM-DD");
    return {
      fromDate: fromDate,
      toDate: toDate,
      branch_id: filterBranch ? filterBranch.id : "",
      customer_id: filterCustomer? filterCustomer.id : "",
      page: page,
      type: "pos",
      search_term: searchInput,
    };
  };
  const createSearchObj = (page) => {
    return {
      search_term: searchInput.toLowerCase(),
      type: "pos",
      page: page,
    };
  };

  const handleFilterSubmit = () => {
    if (startDate === null || endDate === null) {
      ToastError({title: "Please select the dates to filter"});
      return;
    }
    setPaginatedFilteredOrders(createFilterObj(1));
    setFiltered(true);
    if (searched) setSearched(false);
  };

  //customer wise filter
  const handleCustomerFilter = (customer) => {
    setFilterCustomer(customer);
    setCustomerSearchInput("");
  };

  const handleCustomerInputChange = (value, meta) => {
    if (meta?.action !== "input-change") return;
    const numericInput = (value || "").replace(/\D/g, "");
    setCustomerSearchInput(numericInput);
  };

  const fetchCustomersByPhone = async (phone) => {
    const url = BASE_URL + "/settings/get-all-customer";
    const res = await axios.post(
      url,
      { customer_phn_no: phone },
      { headers: { Authorization: `Bearer ${getCookie()}` } }
    );
    return res?.data?.[0] || [];
  };

  useEffect(() => {
    if (customerSearchInput && customerSearchInput.length > 0) {
      setCustomerSearchLoading(true);
      setCustomerSearchResults([]);
      const timer = setTimeout(async () => {
        try {
          const results = await fetchCustomersByPhone(customerSearchInput);
          setCustomerSearchResults(results);
          setCustomerNoOptionMessage(_t(t("No Customer Exist")));
        } catch (error) {
          setCustomerSearchResults([]);
          if (parseInt(authUserInfo?.details?.offline_enable)) {
            ToastError({title: _t(t("Can't search customer in offline mode"))});
          } else {
            ToastError({title: _t(t("Please try again"))});
          }
        } finally {
          setCustomerSearchLoading(false);
        }
      }, 800);
      return () => clearTimeout(timer);
    }

    setCustomerSearchResults([]);
    setCustomerSearchLoading(false);
    setCustomerNoOptionMessage(_t(t("Enter Phone No To Search")));
  }, [customerSearchInput]);

  //branch wise filter
  const handleBranchFilter = (branch) => {
    setFilterBranch(branch);
  };

  //print here
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  //sync order to srb/fbr
  const handleSyncOrder = async (id) => {
    const url = BASE_URL + "/settings/repost-order-forInvoiceNo/" + id;
    setDataPaginating(true);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })

      if (res.data) {
        setDataPaginating(false)
        if (res.data && res.data.status && res.data.message) {
          ToastSuccess(`${_t(t(res.data.message))}`);
          // getSettledOrders();
          if(filtered){
            handleFilterSubmit()
          }else{
            setPaginatedAllOrders()
          }
          return
        }
        setDataPaginating(false)
        ToastSuccess(`${_t(t("Sync Order Success"))}`);
      }
    } catch (err) {
      setDataPaginating(false)
      if (err.response.data.status === 0) {
        ToastError({title: `${_t(t(err.response.data.message))}`});
        return
      }
     ToastError({title: `${_t(t("Please try again"))}`});
    }
  };

  const getIndex = (data, index) => {
    return (
      index + 1 +
      (data.meta.current_page - 1) * data.meta.per_page
    );
  };

  const itemListContent = (item,index,filter=0)=>{
    const currentData = filter ? allOrdersForSearch : allOrders;
    return (
      <tr
        className="align-middle"
        key={index}
      >
        <th
          scope="row"
          className="table-text text-capitalize align-middle text-center"
        >

          {getIndex(currentData, index)}
        </th>

        <td className="table-text text-capitalize align-middle text-center text-secondary table_child_token">
          #{item.token?.id}
        </td>

        <td className="table-text text-capitalize align-middle text-center text-secondary table_child_token">
          {item?.order_no ? "#"+ item.order_no : "-"}
        </td>

        <td className="table-text align-middle text-center table_child_ordertype">
          {item.customer_name}
        </td>

        <td className="table-text align-middle text-center table_child_ordertype">
          {item.delivery_phn_no ? item.delivery_phn_no : "-"}
        </td>
        <td className="table-text align-middle text-center table_child_branch">
          {item.branch_name || "-"}
        </td>

        <td className="table-text align-middle text-center">
          {currencySymbolLeft()}
          {roundFormatPrice(item.total_payable)}
          {currencySymbolRight()}
        </td>

        <td className="table-text text-capitalize align-middle text-center">
          {parseInt(item.is_cancelled) || parseInt(item?.is_refund) === 1 ? (
            <span
              className="btn btn-transparent btn-danger xsm-text text-capitalize px-3"
              onClick={() => {
                setCheckOrderDetails({
                  ...checkOrderDetails,
                  item: item,
                  settle: false,
                });
              }}
              data-toggle="modal"
              data-target="#orderDetails"
            >
              {_t(t(`${parseInt(item.is_cancelled) ? "Cancelled" : "Refund"}`))}
            </span>
          ) : (
            [
              parseInt(item.is_ready) ===
              0 ? (
                <span
                  className="btn btn-transparent btn-secondary xsm-text text-capitalize rounded"
                  onClick={() => {
                    setCheckOrderDetails({
                      ...checkOrderDetails,
                      item: item,
                      settle: false,
                    });
                  }}
                  data-toggle="modal"
                  data-target="#orderDetails"
                >
                  {_t(t("processing"))}
                </span>
              ) : (
                <span
                  className="btn btn-transparent btn-success xsm-text text-capitalize px-4"
                  onClick={() => {
                    setCheckOrderDetails({
                      ...checkOrderDetails,
                      item: item,
                      settle: false,
                    });
                  }}
                  data-toggle="modal"
                  data-target="#orderDetails"
                >
                  {_t(t("Ready"))}
                </span>
              ),
            ]
          )}
          {authUserInfo.permissions !== null &&
            checkPermission(
              authUserInfo.permissions,
              "Order Sync"
            ) && parseInt(item.is_paid) && !parseInt(item?.is_foc) && !parseInt(item.is_cancelled) && !parseInt(item?.is_refund) &&
            (!item.srb_pos_invoice_no && !item.fbr_pos_invoice_no) ? (
            <button
              title="Sync order"
              className="btn btn-success btn-sm ml-2"
              onClick={() => {
                handleSyncOrder(item.id)
              }}
            >
              <i class="fa fa-refresh"></i>
            </button>
          ) : (
            ""
          )}
        </td>

        <td className="table-text align-middle text-center">
          {authUserInfo.permissions !== null &&
            checkPermission(authUserInfo.permissions, "Order History Print") ?
            <button
              className="btn btn-secondary btn-sm rounded"
              onClick={async() => {
                let hashId = "";
                if(parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1 && item?.is_feedback !== 2){
                  hashId = await encryptAES128(item.id);
                }
                setCheckOrderDetails({
                  ...checkOrderDetails,
                  item: {
                    ...item,
                    hashId: hashId
                  },
                  settle: false,
                });
                isSettle.current = item.is_paid
                setTimeout(() => {
                  handleOnlyPrint();
                }, 800);
              }}
            >
              <i className="fa fa-print"></i>
            </button>
          :null}
          {parseInt(getSystemSettings(generalSettings, "accounts_access")) === 1 && 
            item.is_paid && item.is_settled ? (
              <>
                <button
                  title="View Ledger"
                  className="btn btn-primary ml-2 rounded-sm btn-sm"
                  onClick={()=>handlePosLedger(item.id)}                                                    
                >                                                    
                  <i className="fa fa-eye" aria-hidden="true"></i>                                                    
                </button>

                <button
                  className="btn btn-success ml-2 rounded-sm btn-sm"
                  onClick={()=>handlePostLedger(item.id, item.branch_id)}                                                    
                >                                                    
                  <FaFileInvoice />                                                  
                </button>
              </>
            ) : ""
          }
        </td>

        <td className="table-text text-capitalize align-middle text-center table_child_token">
          <Moment format="LT">
            {item.created_at}
          </Moment>
        </td>

        <td className="table-text text-capitalize align-middle text-center table_child_token">
          <Moment format="LT">
          {item?.updated_at}
          </Moment>
        </td>

        <td className="table-text text-capitalize align-middle text-center">
          <Moment format="LL">
            {item.order_date}
          </Moment>
        </td>

        <td className="table-text align-middle text-center">
          {item.user_name}
        </td>
        <td
        scope="col"
        className="table-text align-middle text-center"
        >
          {item.ref_no ? item.ref_no : "-"}
        </td>
        <td className="table-text align-middle text-center">
          <div className="text-capitalize">
            {
              parseInt(item?.is_feedback) === 0 && !item.is_cancelled ? (
                <button
                  title="Feedback"
                  className="btn btn-success px-2 py-1 rounded-sm"
                  type="button"
                  onClick={() => handleOrderFeedback(item)}
                >
                  <i class="fa fa-comments-o" aria-hidden="true"></i>
                </button>
              ) : (
                <span className="cursor-pointer" onClick={() => handleOrderFeedback(item, true)}>
                  {item.customer_feedback?.feedback ?? "-"}
                </span>
              )
            }
            {/* <div className="dropdown-menu">
              <button
                className="dropdown-item sm-text text-capitalize"
                onClick={() => {
                  handleDeleteOrderConfirmation(
                    item
                  );
                }}
              >
                <span className="t-mr-8">
                  <i className="fa fa-trash"></i>
                </span>
                {_t(t("Delete Order"))}
              </button>
            </div> */}
          </div>
        </td>

      </tr>
    )
  }
  return (
    <>
      <Helmet>
        <title>{_t(t("Order history"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-12 t-mb-30 mb-lg-0">
              {/* {loading === true ? (
                pageLoading()
              ) : ( */}
                <div className="t-bg-white ">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading || dataPaginating}/>
                  {/* spin loading ends */}
                  <div className="row gx-2 align-items-center t-pt-15 t-pb-15 t-pl-15 t-pr-15 t-shadow">
                    {/*<div className="col-12 t-mb-15">
                      <ul className="t-list fk-breadcrumb">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-uppercase">
                            {filtered === false && searched === false
                              ? _t(t("Order history"))
                              : _t(t("Filtered order history"))}
                          </span>
                        </li>
                      </ul>
                            </div>*/}
                    <div className="col-md-2 col-sm-6">
                      <ul className="t-list fk-breadcrumb d-flex align-items-center mr-3">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-uppercase">
                            {filtered === false && searched === false
                              ? _t(t("Order history"))
                              : _t(t("Filtered order history"))}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-3 col-sm-6 row d-flex align-items-center">
                      <div className="fk-sort__list mr-1 col-5">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control xsm-text py-2 rounded"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                      </div>
                      <div className="fk-sort__list mr-1 col-1">
                        <span className="fk-sort__icon">
                          <span className="fa fa-long-arrow-right"></span>
                        </span>
                      </div>
                      <div className="fk-sort__list mr-1 col-5">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          styles={customStyle}
                          className="form-control xsm-text py-2 rounded"
                          placeholderText={_t(t("To date"))}
                          shouldCloseOnSelect={false}
                        />
                      </div>
                    </div>
                    {/* large screen  */}
                    <div className="col-md-7 col-sm-12 mt-mb-0 mb-md-0">
                      <ul className="t-list fk-sort row">
                        <li className="col-3">
                            <input
                            type="text"
                            className="form-control border-0 form-control--light-1 rounded"
                            name="search"
                            placeholder={
                              _t(t("Search by token, #B-12")) + ".."
                            }
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                          />
                        </li>
                       
                        <li className="col-3">
                          <Select
                            options={customerSearchResults || []}
                            filterOption={() => true}
                            getOptionLabel={(option) => (option?.name || "" ) + (option?.phn_no ? (" - " + option.phn_no) : "")}
                            getOptionValue={(option) => option.id}
                            className="xsm-text"
                            value={filterCustomer}
                            isClearable
                            onChange={handleCustomerFilter}
                            onInputChange={handleCustomerInputChange}
                            maxMenuHeight="200px"
                            styles={customStyle}
                            noOptionsMessage={() => {
                              return customerSearchLoading ? (
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                customerNoOptionMessage
                              );
                            }}
                          />
                        </li>
                        {authUserInfo.details !== null &&
                          authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter" && (
                            <li
                              className="col-3"
                            >
                              <Select
                                options={branchForSearch && branchForSearch}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                className="xsm-text"
                                value={filterBranch}
                                isClearable
                                onChange={handleBranchFilter}
                                maxMenuHeight="200px"
                                styles={customStyle}
                                placeholder={_t(t("branch")) + ".."}
                              />
                            </li>
                          )}

                        <li className="col-3 d-flex align-items-center">
                          <button
                            className="btn btn-transparent btn-danger xsm-text text-uppercase py-2 rounded mr-2"
                            // onClick={handleDateFilter}
                            onClick={handleFilterSubmit}
                          >
                            {_t(t("Filter"))}
                          </button>
                          <NavLink
                            to="/dashboard/online-orders"
                            className="btn btn-transparent btn-secondary xsm-text text-uppercase py-2 rounded"
                          >
                            {_t(t("Online Odr."))}
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="fk-scroll--order-settle" data-simplebar >
                    <div className="t-pl-15 t-pr-15">
                      <div className="">
                        <table className="table table-bordered table-hover min-table-height mt-4">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                              >
                                {_t(t("Token"))}
                              </th>
                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                              >
                                {_t(t("Invoice No"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Customer"))}
                              </th>

                              <th
                              scope="col"
                              className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Customer Phone"))}
                              </th>

                              <th
                              scope="col"
                              className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Branch"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Total bill"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Status"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("print"))}
                              </th>
                              
                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                              >
                                {_t(t("Time"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                              >
                                {_t(t("Dispatch Time"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Date"))}
                              </th>

                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("User Name"))}
                              </th>

                              <th
                              scope="col"
                              className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Ref No"))}
                              </th>
                              <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Feedback"))}
                              </th>
                            
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!filtered
                              ? [
                                  allOrders && [
                                    allOrders.data.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="10"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      allOrders.data.map((item, index) => {
                                        return itemListContent(item, index)
                                      })
                                    ),
                                  ],
                                ]
                              : [
                                  /* searched data, logic === haveData*/
                                  allOrdersForSearch && [
                                    allOrdersForSearch.data.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="10"
                                          className="table-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      allOrdersForSearch.data.map(
                                        (item, index) => {
                                          return itemListContent(item, index, 1)
                                        }
                                      )
                                    ),
                                  ],
                                ]}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              {/* )} */}
              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !filtered ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {paginationOrderHistory(
                                allOrders,
                                setPaginatedAllOrders
                              )}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingDataOrderHistory(allOrders)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-2 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    // setSearchedOrders({
                                    //   ...searchedOrders,
                                    //   searched: false,
                                    //   branch: null,
                                    // });
                                    setSearched(false);
                                    setFiltered(false);
                                    setStartDate(null);
                                    setEndDate(null);
                                    setFilterBranch(null);
                                  }}
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            {/* pagination function */}
                            {paginationOrderHistory(
                              allOrdersForSearch,
                              (page) => {
                                // if (searched)
                                //   setPaginatedSearchedOrders(
                                //     createSearchObj(page)
                                //   );
                                // else
                                 if (filtered)
                                 setPaginatedSearchOrders(
                                    createFilterObj(page)
                                  );
                              }
                            )}
                          </div>
                          <div className="col-md-3">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {showingDataOrderHistory(allOrdersForSearch)}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
          </div>
        </div>
      </main>

      {/* order print */}
      <OrderPrintView 
        componentRef={componentRef}
        checkOrderDetails={checkOrderDetails}
        taxType = {taxType}
        taxPercent = {checkOrderDetails.item && taxPercent(checkOrderDetails.item?.order_bill,checkOrderDetails.item?.vat,checkOrderDetails.item?.discount_amount)}
        isSettle = {isSettle}
        fbrInvoiceNum = {checkOrderDetails.item && checkOrderDetails.item.fbr_pos_invoice_no}
        srbInvoiceNum = {{
          number: checkOrderDetails.item && checkOrderDetails.item.srb_pos_invoice_no,
          url: checkOrderDetails.item && checkOrderDetails.item?.srb_pos_qr_url,
        }}
        paidMoney = {checkOrderDetails.item && checkOrderDetails.item.paid_amount}
        redeemPoints = {checkOrderDetails.item && Number(checkOrderDetails.item?.redeem_points)}
        availablePoints = {checkOrderDetails.item && Number(checkOrderDetails.item?.available_points)}
        earnedPoints = {checkOrderDetails.item && Number(checkOrderDetails.item?.earned_points)}
      />
      {/* order view*/}
      <OrderDetailsView
        checkOrderDetails = {checkOrderDetails}
        setCheckOrderDetails = {setCheckOrderDetails}
        returnMoneyUsd = {checkOrderDetails.item && (checkOrderDetails.item.paid_amount) - parseFloat(checkOrderDetails.item.total_payable)}
        paidMoney = {checkOrderDetails.item && checkOrderDetails.item.paid_amount}
        handleSettleOrder = {null}
        redeemPoints = {checkOrderDetails.item && Number(checkOrderDetails.item?.redeem_points)}
      />
      <OrderFeedbackModal
        feedbackDetails={feedbackDetails}
        setFeedbackDetails={setFeedbackDetails}
      />
      <ViewAccountSheet
        accountLedger={ledgerData}
        setAccountLedger= {setLedgerData}
      />
    </>
  );
};

export default OrderHistories;
